import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalculator } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <FaCalculator className="footer-icon" />
          <span>#Paisa Pyara</span>
        </div>
        <div className="footer-links">
          <Link to="/">Home</Link>
          <a href="https://www.incometax.gov.in" target="_blank" rel="noopener noreferrer">
            Income Tax Portal
          </a>
        </div>
        <p className="footer-disclaimer">
          For informational purposes only. All calculations are performed client-side for your privacy.
        </p>
        <p className="footer-copy">
          &copy; {new Date().getFullYear()} #Paisa Pyara &middot; 100+ Indian calculators &amp; bill generators, free &amp; private.
        </p>
        <p className="footer-powered">
          Powered by{' '}
          <a
            href="https://www.paisapyara.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-powered-link"
          >
            #Paisa Pyara
          </a>
        </p>
        <p className="footer-contact">
          Contact: <a href="mailto:info@paisapyara.com">info@paisapyara.com</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;


